export default {
	load() {
		return {
			fields: {
				request_number: {
					label: "Číslo žiadosti"
				},
				round_id: {
					label: "Kolo výzvy"
				},
				device: {
					label: "Zariadenie"
				},
				request_state: {
					label: "Stav žiadosti"
				}
			}
		}
	}
}

